import React from 'react';
import usePopup from "../hooks/usePopup";
import Popup from '../Popup/Popup';
import CompesoIFrame from '../General/CompesoIFrame';
import Translation from '../General/Translation';
import UserContentMenu from './UserContentMenu';
import UserContentIcons from './UserContentIcons';

function UserContentCompeso({
    hasLogin, 
    isLoggedIn, 
    features, 
    translation, 
    shopUrl, 
    affiliateSlug, 
    cartCount, 
    hasConcessionShop, 
    hasVoucherShop, 
    myAccountUrl, 
    loginUrl, 
    cinemaUserTextHint, 
    checkoutUrl, 
    logoutUrl, 
    vouchersUrl, 
    concessionsUrl, 
    programOverviewUrl
}) {
    const [popupDisplayed, openPopup, closePopup] = usePopup();

    return (
        <div className='user-content-container'>
            <div className='grid-site-wrapper'>
                <UserContentMenu 
                    hasLogin={hasLogin}
                    isLoggedIn={isLoggedIn}
                    openPopup={openPopup}
                    translation={translation}
                    cartCount={cartCount}
                    hasConcessionShop={hasConcessionShop}
                    hasVoucherShop={hasVoucherShop}
                    programOverviewUrl={programOverviewUrl}
                    features={features}
                    affiliateSlug={affiliateSlug}
                />

                <Popup addClassToPopup="popup-content-user-content" displayPopup={popupDisplayed} onClosePopup={closePopup} translation={translation}>
                    <div className='theme-radius-posters-full'>
                        {popupDisplayed === 'login' ? (
                                isLoggedIn ? (
                                    <div>
                                        <CompesoIFrame 
                                            src={myAccountUrl}
                                            title={''}
                                            id={'compeso-my-account'}
                                            cinemaPath={shopUrl}
                                        /> 

                                        <button className='logout-button' onClick={() => openPopup('logout')}>
                                            <span className='user-content-button-text text-medium-navigation'>
                                                <Translation id="logout_name" trans={translation}>Logout</Translation>
                                            </span>
                                            <UserContentIcons id={'logout'}/> 
                                        </button>
                                    </div> 
                                ) : (
                                    <div>
                                        <CompesoIFrame 
                                            src={loginUrl}
                                            translation={translation}
                                            title={''}
                                            cinemaUserTextHint={cinemaUserTextHint}
                                            id={'compeso-login'}
                                            cinemaPath={shopUrl}
                                        /> 
                                    </div> 
                                )
                        ) : popupDisplayed === 'cart' ? (
                                <CompesoIFrame 
                                    src={checkoutUrl}
                                    title={''}
                                    id={'compeso-checkout'}
                                    cinemaPath={shopUrl}
                                /> 
                        ) : popupDisplayed === 'logout' ? (
                                <CompesoIFrame 
                                    src={logoutUrl}
                                    title='Logout'
                                    id={'compeso-logout'}
                                    cinemaPath={shopUrl}
                                /> 
                        ) : popupDisplayed === 'vouchers' ? (
                                <CompesoIFrame 
                                    src={vouchersUrl}
                                    title=''
                                    id={'compeso-vouchers'}
                                    cinemaPath={shopUrl}
                                /> 
                        ) : popupDisplayed === 'concession' ? (
                                <CompesoIFrame 
                                    src={concessionsUrl}
                                    title=''
                                    id={'compeso-concession'}
                                    cinemaPath={shopUrl}
                                />
                        ) : (
                            ''
                        )}
                    </div>
                </Popup>
            </div>
        </div>
    );
}

export default UserContentCompeso;